export default __webpack_public_path__ + "static/media/equipo.f790cecf.jpg";